import {axios, API, SendRequest} from '@/imports-files/pages/admins/dashboard/clients/new';

export class Job extends SendRequest {
  async getJobData() {
    try {
        const result = await axios.get(API.client.jobs.GET_JOB_DATA,
            {
              headers: this.customHeaderJSON()
            },
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
        return result;
      } catch (error) {
        return error;
      }
  }

  async getJobDataByJobTitle(job_title_id) {
    try {
        const result = await axios.get(API.client.jobs.GET_JOB_BY_TITLE.replace('$job_title_id', job_title_id),
            {
              headers: this.customHeaderJSON()
            },
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
        return result;
      } catch (error) {
        return error;
      }
  }

  async createJob(params) {
    try {
      const result = await axios.post(API.client.jobs.CREATE_JOB,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async updateJob(params, jobId) {
    try {
      const result = await axios.patch(API.client.jobs.UPDATE_JOB.replace('$job_id', jobId),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async getJobTitlesByName(params) {
    try {
      const result = await axios.get(API.client.jobs.GET_JOB_TITLES,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async getDepartmentsByName(params) {
    try {
      const result = await axios.get(API.client.jobs.GET_DEPARTMENTS,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch (error) {
      return error;
    }
  }

  async generateJobDescription(params) {
    try {
      const result = await axios.post(API.client.jobs.GENERATE_DESCRIPTION,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
}
